import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import LoadingSkeleton from "./components/loading.jsx";
import ProtectedRoute from "./hooks/protectedRoute";
import AssetProtectedRoute from "./hooks/assetProtectedRoute";
import TestPage from "./pages/testes/testPage.jsx";
import ChartHistory from "./pages/dashboard/details/chartHistory/chartHistory.jsx";
import AdminDashboard from "./pages/admin/dashboard.jsx";
const Home = React.lazy(() => import("./pages/dashboard/home/home.jsx"));
const AlarmesDashBoard = React.lazy(
  () => import("./pages/dashboard/alarms/alarmsDashboard.jsx"),
);
const AlarmesRealTime = React.lazy(
  () => import("./pages/dashboard/alarms/realtime/alarmsRealtime.jsx"),
);
const Logs = React.lazy(() => import("./pages/logs/logs"));
const AlarmesCadastro = React.lazy(
  () => import("./pages/register/alarms/alarmsRegister.jsx"),
);
const Ativos = React.lazy(() => import("./pages/register/assets/assets.jsx"));
const Usuarios = React.lazy(() => import("./pages/register/users/users.jsx"));
const Atributos = React.lazy(
  () => import("./pages/register/attributes/attributes.jsx"),
);
const Variaveis = React.lazy(
  () => import("./pages/register/variables/variables.jsx"),
);
const UsuariosGrupo = React.lazy(
  () => import("./pages/register/users/groups/usersGroups.jsx"),
);
const AtivosGrupo = React.lazy(
  () => import("./pages/register/assets/groups/assetsGroups.jsx"),
);
const Mapeamento = React.lazy(
  () => import("./pages/register/variables/mappings/mappings.jsx"),
);
const Input = React.lazy(
  () => import("./pages/register/variables/inputs/inputs.jsx"),
);
const Perfil = React.lazy(() => import("./pages/profiles/profiles.jsx"));
const Detalhes = React.lazy(
  () => import("./pages/dashboard/details/general/detailsGeneral.jsx"),
);
const EventosAtivoTabela = React.lazy(
  () => import("./pages/dashboard/details/events/events.jsx"),
);
const Totalizadores = React.lazy(
  () => import("./pages/dashboard/details/totalizers/totalizers.jsx"),
);
const Login = React.lazy(() => import("./pages/login/login.jsx"));
const EsqueceuSenha = React.lazy(
  () => import("./pages/login/forgotPassword.jsx"),
);
const SemPermissao = React.lazy(
  () => import("./components/pageNoPermission.jsx"),
);
const NaoEncontrada = React.lazy(() => import("./components/pageNotFound.jsx"));

const Modelos = React.lazy(
  () => import("./pages/register/assets/models/models.jsx"),
);

const AlarmesComponente = React.lazy(
  () => import("./pages/maintaince/alarms/alarmsComponent.jsx"),
);
const EventsDashboardTabela = React.lazy(
  () => import("./pages/dashboard/events/events.jsx"),
);

const isDev = process.env.REACT_APP_ENVIRONMENT == "dev";
const AppRoutes = () => (
  <Suspense fallback={<LoadingSkeleton />}>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/login/esqueceuSenha" element={<EsqueceuSenha />} />
      {isDev && <Route path="/testes" element={<TestPage />} />}
      <Route path="/semPermissao" element={<SemPermissao />} />
      <Route
        exact
        path="/"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route exact path="/admin-2s/dashboard" element={<AdminDashboard />} />

      <Route
        path="/alarmes/dashboard/sumario"
        element={
          <ProtectedRoute feature="variable_alarms">
            <AlarmesDashBoard apenasReconhecidos={true} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alarmes/dashboard/historico"
        element={
          <ProtectedRoute feature="variable_alarms">
            <AlarmesDashBoard apenasReconhecidos={false} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alarmes/dashboard/temporeal"
        element={
          <ProtectedRoute feature="variable_alarms">
            <AlarmesRealTime />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alarmesComponente"
        element={
          <ProtectedRoute feature="variable_alarms">
            <AlarmesComponente />
          </ProtectedRoute>
        }
      />
      <Route
        path="/eventos"
        element={
          <ProtectedRoute feature="events">
            <EventsDashboardTabela />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alarmes-cadastro"
        element={
          <ProtectedRoute
            module="register"
            action="alarms"
            feature="variable_alarms"
          >
            <AlarmesCadastro />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ativos"
        element={
          <ProtectedRoute module="register" action="assets">
            <Ativos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/usuarios"
        element={
          <ProtectedRoute module="register" action="users">
            <Usuarios />
          </ProtectedRoute>
        }
      />
      <Route
        path="/atributos"
        element={
          <ProtectedRoute module="register" action="attributes">
            <Atributos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/variaveis"
        element={
          <ProtectedRoute module="register" action="variables">
            <Variaveis />
          </ProtectedRoute>
        }
      />
      <Route
        path="/logs"
        element={
          <ProtectedRoute module="actions" action="logsView">
            <Logs />
          </ProtectedRoute>
        }
      />

      <Route
        path="/usuarios/grupo"
        element={
          <ProtectedRoute module="register" action="users">
            <UsuariosGrupo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ativos/grupo"
        element={
          <ProtectedRoute module="register" action="assets">
            <AtivosGrupo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ativos/modelos"
        element={
          <ProtectedRoute module="register" action="assets">
            <Modelos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/variaveis/mapeamento"
        element={
          <ProtectedRoute module="register" action="variables">
            <Mapeamento />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inputs"
        element={
          <ProtectedRoute module="register" action="variables">
            <Input />
          </ProtectedRoute>
        }
      />
      <Route
        path="/perfil"
        element={
          <ProtectedRoute>
            <Perfil />
          </ProtectedRoute>
        }
      />
      <Route
        path="/detalhes/:assetSlug"
        element={
          <AssetProtectedRoute>
            <Detalhes />
          </AssetProtectedRoute>
        }
      />
      <Route
        path="/detalhes/:assetSlug/eventos"
        element={
          <AssetProtectedRoute feature="events">
            <EventosAtivoTabela />
          </AssetProtectedRoute>
        }
      />
      <Route
        path="/detalhes/:assetSlug/totalizadores"
        element={
          <AssetProtectedRoute
            features={[
              "totalizers_loading",
              "totalizers_unloading",
              "totalizers_valve_opening",
              "totalizers_pressure_alarms",
            ]}
          >
            <Totalizadores />
          </AssetProtectedRoute>
        }
      />
      <Route
        path="/detalhes/:assetSlug/historico-carta"
        element={
          <AssetProtectedRoute feature="dynamometer_cards">
            <ChartHistory />
          </AssetProtectedRoute>
        }
      />
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <NaoEncontrada />
          </ProtectedRoute>
        }
      />
    </Routes>
  </Suspense>
);

export default AppRoutes;
